var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['email-component', 'button-component', { selected: _vm.selected }],on:{"click":_vm.handleClick}},[_c('div',{staticClass:"component-content",style:(_vm.getContainerStyles())},[_c('a',{staticClass:"email-button",style:(_vm.getButtonStyles())},[_vm._v(" "+_vm._s(_vm.componentData.content)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }